import { useMemo } from 'react';
import { useWellnessMetrics } from '../../../hooks/analytics/useWellnessAnalytics';
import { AnalyticsCard } from '../shared/AnalyticsCard';
import { palette } from '../shared/theme';
import { WellnessPrePostBarChart } from './WellnessPrePostBarChart';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { formatWellnessExportData } from './wellnessUtils';
import { MetricTooltip } from './MetricTooltip';
import { WellnessFormSelect } from './WellnessFormSelect';
import { SkeletonLoader } from '../shared/SkeletonLoader';
import { useSelectedWellnessForm } from '../../../hooks/analytics/useSelectedWellnessForm';

interface WellnessPrePostCardProps {
  filters: WellnessFilter;
}

export function WellnessPrePostCard({ filters }: WellnessPrePostCardProps) {
  const { data, isLoading, error } = useWellnessMetrics(filters);
  const { forms } = useSelectedWellnessForm(filters);

  const exportData = useMemo(() => formatWellnessExportData(data || null), [data]);

  const accent = palette.indigo;
  return (
    <AnalyticsCard
      title="Pre vs Post Wellness Metrics"
      headerActions={<MetricTooltip questions={data?.questions ?? []} />}
      exportData={exportData}
      exportFileName="wellness-pre-post"
      accent={accent}
    >
      {forms.length > 1 && (
        <div className="-mt-6 mb-2">
          <WellnessFormSelect filters={filters} />
        </div>
      )}
      {isLoading ? (
        <SkeletonLoader variant="chart" height="h-64" />
      ) : error ? (
        <div className="py-8 text-center text-[var(--anl-text-muted)]">
          <p className="text-sm">Error loading data</p>
        </div>
      ) : (
        <>
          <div className="mb-2 hidden text-xs italic text-[var(--anl-text-muted)] sm:block">
            Hover chart bars for questionnaire details
          </div>
          <WellnessPrePostBarChart data={data || null} height={350} />
        </>
      )}
    </AnalyticsCard>
  );
}
